import entekhabFavicon from 'assets/html-pwa/Entekhab/favicon.ico';
import entekhabLogo180 from 'assets/html-pwa/Entekhab/180-type2.png';
import keepaFavicon from 'assets/html-pwa/Keepa/favicon.ico';
import keepaLogo180 from 'assets/html-pwa/Keepa/logo180.png';
import hamtalandFavicon from 'assets/html-pwa/Hamtaland/favicon.ico';
import hamtalandLogo180 from 'assets/html-pwa/Hamtaland/hamtaland - 180-min.png';
import rayansaipaFavicon from 'assets/html-pwa/Rayansaipa/favicon.ico';
import rayansaipaLogo180 from 'assets/html-pwa/Rayansaipa/180-180 (1).png';
import tisaFavicon from 'assets/html-pwa/Tisa/favicon.ico';
import tisaLogo180 from 'assets/html-pwa/Tisa/176.png';
import saanaFavicon from 'assets/html-pwa/Saana/favicon.ico';
import saanaLogo180 from 'assets/html-pwa/Saana/176.png';
import arbaeenFavicon from 'assets/html-pwa/Arbaeen/favicon.ico';
import arbaeenLogo180 from 'assets/html-pwa/Arbaeen/176.png';

export const BRAND_CONFIGS = {
	hamtaland: {
		name: 'همتالند',
		title: 'همتالند',
		favicon: hamtalandFavicon,
		logo180: hamtalandLogo180,
		themeColor: '#ffffff',
		description: 'سرزمین خرید اعتباری',
	},
	keepa: {
		name: 'Keepa',
		title: 'اپلیکیشن کیف پول اعتباری - کیپا',
		favicon: keepaFavicon,
		logo180: keepaLogo180,
		themeColor: '#35306f',
		description:
			'کیپا، کیف پول اعتباری شما برای خرید اقساطی از بیش از 5 هزار فروشگاه در کشور است. با کیپا می توانید به راحتی اقساطی خرید کنید، از اعتبار خود مطلع شوید و اقساط خود را مدیریت کنید.',
		url: 'https://pwa.keepa.ir',
	},
	entekhab: {
		name: 'Entekhabino',
		title: 'اپلیکیشن کیف پول اعتباری - انتخابینو',
		favicon: entekhabFavicon,
		logo180: entekhabLogo180,
		themeColor: '#008F55',
		url: 'https://app.entekhabino.ir',
	},
	rayansaipa: {
		name: 'Rayan Saipa',
		title: 'لیزینگ رایان - سایپا',
		favicon: rayansaipaFavicon,
		logo180: rayansaipaLogo180,
		themeColor: '#ffff',
		description: 'سامانه برخط اعطای اعتبار و تسهیلات',
	},
	tisa: {
		name: 'Tisa pay',
		title: 'تیسا پی؛ سامانه خرید و پرداخت اعتباری و اقساطی',
		favicon: tisaFavicon,
		logo180: tisaLogo180,
		themeColor: '#3D85C6',
		description:
			'تیسا پی سامانه خرید و اعطای اعتبار اقساطی از طریق راهکارهای نوین مالی در قالب طرح های متنوع',
	},
	saana: {
		name: 'Saana pay',
		title: 'بُن‌کارت رفاهی سانا',
		favicon: saanaFavicon,
		logo180: saanaLogo180,
		themeColor: '#3D85C6',
		description: 'خرید از فروشگاه‌های زنجیره‌ای',
	},
	arbaeen: {
		name: 'اربعین',
		title: 'اربعین؛ سامانه خرید و پرداخت اعتباری و اقساطی',
		favicon: arbaeenFavicon,
		logo180: arbaeenLogo180,
		themeColor: '#3D85C6',
	},
};

export const STARTUP_IMAGE_MEDIA_QUERIES = [
	'screen and (device-width: 768px) and (device-height: 1024px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)',
	'screen and (device-width: 320px) and (device-height: 568px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)',
	'screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)',
	'screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)',
	'screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)',
	'screen and (device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)',
	'screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)',
	'screen and (device-width: 414px) and (device-height: 736px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)',
	'screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)',
	'screen and (device-width: 414px) and (device-height: 736px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)',
	'screen and (device-width: 1024px) and (device-height: 1366px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)',
	'screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)',
	'screen and (device-width: 834px) and (device-height: 1112px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)',
	'screen and (device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)',
	'screen and (device-width: 1024px) and (device-height: 1366px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)',
	'screen and (device-width: 834px) and (device-height: 1194px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)',
	'screen and (device-width: 834px) and (device-height: 1112px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)',
	'screen and (device-width: 320px) and (device-height: 568px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)',
	'screen and (device-width: 834px) and (device-height: 1194px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)',
	'screen and (device-width: 768px) and (device-height: 1024px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)',
];

export const getBrandConfig = (brandFlags) => {
	if (brandFlags.isHamtaland) return BRAND_CONFIGS.hamtaland;
	if (brandFlags.isKeepa || brandFlags.isDemo) return BRAND_CONFIGS.keepa;
	if (brandFlags.isEntekhab) return BRAND_CONFIGS.entekhab;
	if (brandFlags.isRayansaipa) return BRAND_CONFIGS.rayansaipa;
	if (brandFlags.isTisa) return BRAND_CONFIGS.tisa;
	if (brandFlags.isSaana) return BRAND_CONFIGS.saana;
	if (brandFlags.isArbaeen) return BRAND_CONFIGS.arbaeen;
};
